<template>
  <div>
    <vs-popup class="sales-quote-email-log-popup"
              id="popup"
              :title='`PRODUCT ORDER INVOICE EMAIL LOG`'
              :active.sync="open"
              :buttons-hidden="true">
          <vs-table class="my-8" hoverFlat id="quote_item_table" :data="emailLogList" stripe>
            <template slot="thead">
              <vs-th>NUMBER</vs-th>
              <vs-th>DATE/TIME</vs-th>
              <vs-th>STAFF USER (SENT BY)</vs-th>
              <vs-th>CUSTOMER USER (SENT TO)</vs-th>
              <vs-th>CUSTOMER USER EMAIL</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr"
                    v-for="(tr_item, indextr) in data">
              <vs-td :data="data[indextr].number">
                {{data[indextr].number}}
              </vs-td>
              <vs-td :data="data[indextr].created_at">
                {{ __dateTimeFormatter(data[indextr].created_at) }}
              </vs-td>
              <vs-td>
                {{ data[indextr].created_by_staff_name }}
              </vs-td>
              <vs-td>
                {{ data[indextr].customer_user_name }}
              </vs-td>
              <vs-td>
                {{ data[indextr].customer_user_email }}
              </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get('customer')

export default {
  name: "ProductOrderInvoiceEmailLogPopUp",
  data() {
    return {
      invoiceId:null,
      open: false,
      emailLogList: []
    }
  },
  methods:{
    async openPopUp(id){
      this.invoiceId = id
      await this.fetchEmailLog()
      this.open = true
    },
    async fetchEmailLog(){
      this.$vs.loading()
      const {data} = await CustomerRepository.getProductOrderInvoiceEmailLog(this.invoiceId)
      this.emailLogList = data.data || []
      this.$vs.loading.close()
    }
  }
}
</script>

<style scoped>

.sales-quote-email-log-popup >>> .vs-popup {
  min-width: 50% !important;
}
.label {

}

</style>
